module.exports = __webpack_public_path__ + "img/up4.6be34fb5.png";